export default __webpack_public_path__ + "static/media/desktop404.d410606e.svg";